import { useState } from "react";
import { motion } from "framer-motion";
import { Send, Mail } from "lucide-react";

const CAL_LINK = "https://cal.com/kalza-studio-hdho6x";
const EMAIL = "hello@kalzastudio.com";

export default function ContactPagePL() {
  const [form, setForm] = useState({ name: "", email: "", website: "", service: "", message: "" });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <main data-testid="contact-page-pl">
      <section className="pt-32 pb-20 md:pb-28 bg-white min-h-screen">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            <motion.div initial={{ opacity: 0, x: -30 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.6 }}>
              <h1 className="mb-6">
                <span className="font-display text-5xl md:text-6xl lg:text-7xl text-[#1C1210] block">POROZMA</span>
                <span className="font-accent text-5xl md:text-6xl lg:text-7xl text-[#BE123C] block">wiajmy.</span>
              </h1>
              <p className="font-body text-base text-[#6B6560] leading-relaxed max-w-md mb-8">
                Jeśli coś w tym, jak Twoja marka wygląda w sieci, nie czuje się dobrze, zacznij tutaj. Napisz mi trochę o swoim biznesie i o tym, co się dzieje. Odpowiem w ciągu 48 godzin.
              </p>
              <div className="flex items-center gap-3 mb-4">
                <Mail size={16} className="text-[#BE123C]" />
                <a href={`mailto:${EMAIL}`} className="font-body text-sm text-[#6B6560] hover:text-[#BE123C] transition-colors duration-300">{EMAIL}</a>
              </div>
              <div className="mt-8 p-6 bg-[#f5f5f7] border border-[#e5e2de]">
                <p className="font-body text-sm text-[#6B6560] leading-relaxed mb-4">Wolisz porozmawiać? Umów bezpłatną 30-minutową rozmowę. Zapytam o Twój biznes, rzucę okiem na to, co się dzieje, i powiem Ci, na czym skupiłabym się w pierwszej kolejności.</p>
                <a href={CAL_LINK} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-[#BE123C] text-white font-body font-medium text-xs tracking-[2px] uppercase px-6 py-3 hover:bg-[#9F1239] transition-colors duration-300">
                  UMÓW ROZMOWĘ
                </a>
              </div>
            </motion.div>

            <motion.div initial={{ opacity: 0, x: 30 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.6, delay: 0.2 }}>
              <div className="space-y-5">
                <div>
                  <label className="font-body text-sm font-medium text-[#1C1210] mb-2 block">Imię</label>
                  <input type="text" name="name" value={form.name} onChange={handleChange} className="w-full font-body text-sm border border-[#E8E3DE] px-4 py-3 focus:outline-none focus:border-[#BE123C] transition-colors duration-300 bg-white" />
                </div>
                <div>
                  <label className="font-body text-sm font-medium text-[#1C1210] mb-2 block">Email</label>
                  <input type="email" name="email" value={form.email} onChange={handleChange} className="w-full font-body text-sm border border-[#E8E3DE] px-4 py-3 focus:outline-none focus:border-[#BE123C] transition-colors duration-300 bg-white" />
                </div>
                <div>
                  <label className="font-body text-sm font-medium text-[#1C1210] mb-2 block">Adres strony <span className="text-[#6B6560]/50">(opcjonalnie)</span></label>
                  <input type="url" name="website" value={form.website} onChange={handleChange} className="w-full font-body text-sm border border-[#E8E3DE] px-4 py-3 focus:outline-none focus:border-[#BE123C] transition-colors duration-300 bg-white" />
                </div>
                <div>
                  <label className="font-body text-sm font-medium text-[#1C1210] mb-2 block">Czego szukasz?</label>
                  <select name="service" value={form.service} onChange={handleChange} className="w-full font-body text-sm border border-[#E8E3DE] px-4 py-3 focus:outline-none focus:border-[#BE123C] transition-colors duration-300 bg-white text-[#6B6560]">
                    <option value="">Wybierz opcję</option>
                    <option value="discovery">Bezpłatna rozmowa wstępna</option>
                    <option value="sprint">Brand Reality Check</option>
                    <option value="foundation">Brand Foundation</option>
                    <option value="visual">Full Brand System</option>
                    <option value="unsure">Jeszcze nie wiem</option>
                  </select>
                </div>
                <div>
                  <label className="font-body text-sm font-medium text-[#1C1210] mb-2 block">Powiedz mi, co się teraz dzieje z Twoją marką</label>
                  <textarea name="message" value={form.message} onChange={handleChange} rows={5} className="w-full font-body text-sm border border-[#E8E3DE] px-4 py-3 focus:outline-none focus:border-[#BE123C] transition-colors duration-300 bg-white resize-none" />
                </div>
                <button className="inline-flex items-center justify-center gap-2 bg-[#BE123C] text-white font-body font-medium text-xs tracking-[2px] uppercase px-8 py-4 hover:bg-[#9F1239] transition-colors duration-300 w-full md:w-auto">
                  WYŚLIJ WIADOMOŚĆ <Send size={14} />
                </button>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </main>
  );
}
